import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import ProfilePostsContainer from "~/Containers/ProfilePostsContainer";
import Tile from "~/Components/Tile";
import Section from "~/Components/Section";

const FavoriteTags = ({ chimneyName, favTags }) => (
  <Section title={`${chimneyName} Chimney's Favorite File Unders`}>
    <span className="fileUnderTag tagLg">
      {favTags.map((t) => (
        <Link to={`/tag/${t.tag_slug}`}>{t.tag}</Link>
      ))}
    </span>
  </Section>
);
const ProfilePage = ({ match }) => {
  const { slug } = match.params;
  return (
    <div className="home-page-component">
      <div className="home-component">
        <ProfilePostsContainer
          slug={slug}
          infinite
          componentType={Tile}
          render={({ items, data, loadMore, loading }) => (
            <div>
              {data.chimneyName && (
                <Helmet>
                  <title>____ of the Day | {data.chimneyName} Chimney | Dream Chimney</title>
                </Helmet>
              )}
              {data.chimneyName && <div className="pageTitle">{data.chimneyName} Chimney</div>}

              <Row noGutters className="minimalGutter">
                {items &&
                  items.map((item, index) => (
                    <Col xl={4} lg={6} xs={12} key={item.id}>
                      {index === 2 ? <FavoriteTags chimneyName={data.chimneyName} favTags={data.favTags} /> : <Tile archive otd={item} />}
                    </Col>
                  ))}
              </Row>
              <div>{loadMore}</div>
            </div>
          )}
        />
      </div>
    </div>
  );
};

export default ProfilePage;
